import { useTranslation } from 'react-i18next'
import { ConfirmDialog } from './ConfirmDialog'

interface UnsavedChangesDialogProps {
  onConfirm: () => void
  onCancel: () => void
}

/**
 * The one generic "you have unsaved changes" confirmation, shared by every
 * navigation exit path (left-nav, breadcrumb, brand click, Sign Out, tab
 * switch) and every entity-editor kind. Intentionally states only that there
 * are unsaved changes and asks whether to discard them — never names the
 * specific editor, tab, or field involved.
 */
export function UnsavedChangesDialog({ onConfirm, onCancel }: UnsavedChangesDialogProps) {
  const { t } = useTranslation()
  return (
    <ConfirmDialog
      title={t('common.unsavedChangesDialog.title')}
      message={t('common.unsavedChangesDialog.message')}
      confirmLabel={t('common.unsavedChangesDialog.discard')}
      cancelLabel={t('common.unsavedChangesDialog.cancel')}
      danger
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  )
}
